/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './setup-storage.html';

import { $root } from '../../player/player';
import { mixinType } from '../../util.type';
import FileSystemType from '../file/system/file-system-type';
import focus from '../focus/focus-directive';
import SetupHeader from './setup-header';

export default defineComponent({
  name: 'SetupStorage',
  template,
  components: { SetupHeader },
  created() {
    this.submitted = false;
    this.getAllUnits();
    this.checkStorageInterval = setInterval(() => {
      this.getAllUnits();
    }, 5000);
  },
  destroyed() {
    clearInterval(this.checkStorageInterval);
  },
  directives: { focus },
  data() {
    return mixinType(
      {
        field: {
          storage: {
            label: 'Storage',
            value: this.storage
          }
        },
        isExternalAvailable: false
      },
      /**
       * @type {{
       *   checkStorageInterval: ReturnType<typeof setInterval>;
       *   submitted: boolean;
       * }}
       */
      ({})
    );
  },
  emits: {
    back() {},
    /**
     * @param {string} storage
     */
    submit(storage) {}
  },
  methods: {
    getAllUnits() {
      const { fileSystemManager } = $root(this);
      fileSystemManager.getAllUnits().then((fileSystemUnits) => {
        const externalFileSystemUnits = fileSystemUnits.filter(
          (fileSystemUnit) =>
            fileSystemUnit.getType() === FileSystemType.Usb ||
            fileSystemUnit.getType() === FileSystemType.SdCard
        );
        this.isExternalAvailable =
          externalFileSystemUnits && externalFileSystemUnits.length > 0;
      });
    },
    /**
     * @param {string} storage
     */
    selectStorage(storage) {
      this.field.storage.value = storage;
    },
    onBack() {
      this.$emit('back');
    },
    onReset() {
      this.field.storage.value = this.defaultStorage;
    },
    onSubmit() {
      this.$emit('submit', this.field.storage.value);
    }
  },
  props: {
    defaultStorage: { type: String, required: true },
    isOnline: { type: Boolean, required: true },
    storage: { type: String, required: true }
  }
});
